import { telegram as rutelegram } from "src/i18n/dictionaries/ru/telegram";

export const telegram: Record<keyof typeof rutelegram, string> = {
  "queries.useTelegramAuth.error": "Something went wrong",
};
